var render = function render(){var _vm=this,_c=_vm._self._c;return _c('organization-users',{attrs:{"organization-slug":_vm.organizationSlug,"load-event-templates":true}})
}
var staticRenderFns = []

export { render, staticRenderFns }